import { render, staticRenderFns } from "./ChangeEmailActivationEmailSent.vue?vue&type=template&id=3f9cebc0&scoped=true&"
import script from "./ChangeEmailActivationEmailSent.vue?vue&type=script&lang=ts&"
export * from "./ChangeEmailActivationEmailSent.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeEmailActivationEmailSent.vue?vue&type=style&index=0&id=3f9cebc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9cebc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
